const QUOTATION_STATUS_LABELS = {
  draft: 'Borrador',
  sent: 'Enviada',
  accepted: 'Aceptada',
  rejected: 'Rechazada',
  deleted: 'Eliminada',
};

const getQuotationStatusLabel = (status) => {
  if (!status) return 'Sin estado';
  const normalized = String(status).trim().toLowerCase();
  return QUOTATION_STATUS_LABELS[normalized] || status;
};

export { QUOTATION_STATUS_LABELS, getQuotationStatusLabel };
